import { http } from "../../utils/config";

const pointPromotionAPI = {
    getAll: (data) => {
        return http.get('/api/v1/serviceconnect/promotion/get-all', data);
    },
  
    getDashboard: (params = {}) => {
        const {
            keySearch = '',
            phoneSearch = '',
            promotionId = '',
            order_status = '',
            selectedDates = '',
            source = '',
        } = params;

        let start_date = '';
        let end_date = '';

        if (selectedDates && selectedDates.length > 0) {
            start_date = selectedDates[0];
            end_date = selectedDates[1];
        }

        const queryParams = new URLSearchParams({
            ...(keySearch && { keySearch }),
            ...(phoneSearch && { phoneSearch }),
            ...(promotionId && { promotionId }),
            ...(order_status && { order_status }),
            ...(start_date && { start_date }),
            ...(end_date && { end_date }),
            ...(source && { source })
        });

        return http.get(`/api/v1/serviceconnect/point-promotion-for-customer/cms/histories/dashboard?${queryParams}`);
    },

    getHistoryByCustomerId: (id, params = {}) => {
      const {
        page = 1,
        per_page = 15,
        sort_by = 'created_at',
        sort_order = 'desc'
      } = params;

      const queryParams = new URLSearchParams({
        page: page.toString(),
        per_page: per_page.toString(),
        sort_by,
        sort_order,
      });

      return http.get(`/api/v1/serviceconnect/point-promotion-for-customer/cms/histories/${id}/customer?${queryParams}`);
    },

    // Lịch sử điểm TỔNG HỢP của 1 khách: gồm tất cả loại biến động điểm
    // (TRANSACTION, GIVEPOINT, EVENT, CHANGEPOINT, PROMOTION, GIFTEXCHANGE, EXPIRED, DEDUCTPOINT...)
    getPointHistoriesByCustomerId: (id, params = {}) => {
      const {
        page = 1,
        size = 15,
        type,
        fluctuation_type,
        sort = 'created_at',
        dir = 'DESC',
      } = params;

      const queryParams = new URLSearchParams({
        has_paginate: '1',
        page: page.toString(),
        size: size.toString(),
        sort,
        dir,
        ...(type && { type }),
        ...(fluctuation_type && { fluctuation_type }),
      });

      return http.get(`/api/v1/serviceconnect/point-histories/histories/${id}/customer?${queryParams}`);
    },
};

// Error handling wrapper
export const withErrorHandling = (apiFunction) => {
  return async (...args) => {
    try {
      const response = await apiFunction(...args);
      return response;
    } catch (error) {
      console.error('API Error:', error);

      // Handle different types of errors
      if (error.response) {
        // Server responded with error status
        const { status, data } = error.response;
        switch (status) {
          case 400:
            throw new Error(data.message || 'Dữ liệu không hợp lệ');
          case 401:
            throw new Error('Bạn cần đăng nhập để thực hiện thao tác này');
          case 403:
            throw new Error('Bạn không có quyền thực hiện thao tác này');
          case 404:
            throw new Error('Không tìm thấy khách hàng');
          case 422:
            throw new Error(data.message || 'Dữ liệu không hợp lệ');
          case 500:
            throw new Error(data.message || "Lỗi server, vui lòng thử lại sau");
          default:
            throw new Error(data.message || 'Đã có lỗi xảy ra');
        }
      } else if (error.request) {
        // Network error
        throw new Error('Không thể kết nối đến server');
      } else {
        // Other error
        throw new Error(error.message || 'Đã có lỗi xảy ra');
      }
    }
  };
};

// Wrapped API functions with error handling
export const pointPromotionAPIWithErrorHandling = {
  getAll: withErrorHandling(pointPromotionAPI.getAll),

  getDashboard: withErrorHandling(pointPromotionAPI.getDashboard),
  getHistoryByCustomerId: withErrorHandling(pointPromotionAPI.getHistoryByCustomerId),
  getPointHistoriesByCustomerId: withErrorHandling(pointPromotionAPI.getPointHistoriesByCustomerId),
};

export default pointPromotionAPI;